import React from 'react';
import { Modal, TextInput } from '@mantine/core';
import { Button } from '../../../components/Button';
import type { E2eRunTier } from '../../../services/e2e-runner/e2e-runner.service';
import classes from '../tenants-page.module.scss';

type E2eRunConfirmModalProps = {
  tier: E2eRunTier | null;
  branch: string;
  isBranchValid: boolean;
  defaultBranch: string | null;
  isBusy: boolean;
  onBranchChange: (value: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
};

const TIER_DURATION: Record<E2eRunTier, string> = {
  gate: '~50 דקות',
  full: '~4 שעות',
};

export const E2eRunConfirmModal: React.FC<E2eRunConfirmModalProps> = ({
  tier,
  branch,
  isBranchValid,
  defaultBranch,
  isBusy,
  onBranchChange,
  onCancel,
  onConfirm,
}) => {
  return (
    <Modal
      opened={tier !== null}
      onClose={onCancel}
      title="הפעלת ריצת בדיקות"
      centered
      radius="md"
      withinPortal
      closeOnClickOutside={false}
      closeButtonProps={{ 'data-testid': 'e2e-run-confirm-close' } as Record<string, string>}
    >
      <div className={classes.e2eRunConfirmText} data-testid="e2e-run-confirm-body">
        <span>{`רמה: ${tier ?? ''}`}</span>
        <span>{`משך צפוי: ${tier ? TIER_DURATION[tier] : ''}`}</span>
        <span>מוחק ומאתחל את חברת הבדיקה</span>
        <span>מבצע חיובי אשראי אמיתיים</span>
      </div>
      <TextInput
        label="ענף לבדיקה"
        placeholder={defaultBranch ?? 'develop'}
        value={branch}
        onChange={(event) => onBranchChange(event.currentTarget.value)}
        error={branch.length === 0 ? 'שדה חובה' : !isBranchValid ? 'שם ענף לא תקין' : undefined}
        size="md"
        radius="md"
        data-testid="e2e-run-confirm-branch"
      />
      <div className={classes.modalActions}>
        <Button variant="cancel" onClick={onCancel} disabled={isBusy} dataTestId="e2e-run-confirm-cancel">
          ביטול
        </Button>
        <Button variant="save" onClick={onConfirm} disabled={!isBranchValid} loading={isBusy} loadingLabel="מפעיל..." dataTestId="e2e-run-confirm-launch">
          הפעל
        </Button>
      </div>
    </Modal>
  );
};
